export const breakpoints = {
  // Reference width + 1 (mobile first); read as "min width for this band".
  // `xs` follows Tailwind's sm (640) rather than a device width, so it does not age out.
  base: '0px',
  xs: '641px',
  sm: '769px',
  md: '970px',
  lg: '1171px',
  xl: '1441px',
  '2xl': '1921px',
};
